import React from "react"
import styled from 'styled-components';
import { Link } from "gatsby"
import ItemStyles from "../../../../styles/item-styles"
import { capetalize, cutAddress } from "../../../../../helpers"

const ItemCardMore = (props) => {
    const { description, name, slug, location, titleImage, subway } = props.data
    
    const excerpt = description.split(' ').slice(0, 55).join(' ')
    const { address } = location
    const addressCut = cutAddress(address)


    return(
        <ItemStyles>
            <ImgContainer>
                <Link to={`/${slug}`}><img src={titleImage} alt={name} /></Link>
            </ImgContainer>
            <DescriptionContainer>
                <HeadContainer>
                    <Link to={`/${slug}`}>{name}</Link>
                </HeadContainer>              
                <Subway>Nearest Metro Station: {capetalize(subway)}</Subway>
                <address>{addressCut}</address>
                <Description>
                    <TextContainer dangerouslySetInnerHTML={{ __html: excerpt }} />               
                </Description>
            </DescriptionContainer>
        </ItemStyles>
    )

}

const ImgContainer = styled.div`
    position: relative;
    padding: 10px 0;
    max-width: 160px;
    img {
        box-shadow: 0 0 0 1px #d4d4d4;
        border: 2px solid #fff;
    }
    a {
        border-bottom: none;
    }
`;

const DescriptionContainer = styled.div`
    padding: 10px 0;
`;

const TextContainer = styled.div`
`;

const HeadContainer = styled.div`
    font-size: 2rem;
    margin: 0 0 0.5rem;
    text-align: left;
    line-height: 1.3;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    a {
        border-bottom: 2px solid #F00;
    }
`;

const Subway = styled.div`
    display: flex;
`;

const Description = styled.div`
    p {
        display: inline;
    }
    a {
        color: ${props => props.theme.red};
        position: relative;
        &:after {
        height: 2px;
        background: red;
        content: '';
        width: 0;
        position: absolute;
        transform: translateX(-50%);
        transition: width 0.4s;
        transition-timing-function: cubic-bezier(1, -0.65, 0, 2.31);
        left: 50%;
        margin-top: 1.8rem;
        }
        &:hover,
        &:focus {
        outline: none;
        &:after {
            width: 60px;
        }
        }
    }

`;



export default ItemCardMore